import { render, staticRenderFns } from "./myTrainingStatisticDialog.vue?vue&type=template&id=b4f4d238&scoped=true"
import script from "./myTrainingStatisticDialog.vue?vue&type=script&lang=js"
export * from "./myTrainingStatisticDialog.vue?vue&type=script&lang=js"
import style0 from "./myTrainingStatisticDialog.vue?vue&type=style&index=0&id=b4f4d238&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f4d238",
  null
  
)

export default component.exports